/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { type CSSProperties, useState } from 'react';
// eslint-disable-next-line import/no-cycle
import { FieldType, type Target } from '../../../index';
import ListItem from './ListItem';
import { sumClasses } from '../../../../../utils/misc';

type ListProps = {
  listId: string;
  labelId: string;
  listClassName: string;
  options: any;
  name: string;
  currentIndex: number;
  listboxStyle: CSSProperties;
  currentSelection: any;
  listref: React.RefObject<HTMLUListElement | null>;
  defaultValue: any;
  type?: FieldType;
  expanded?: boolean;
  limit?: number;
  columns?: number;
  iconOnTheRight?: boolean;
  handleItemClick: (item: any, isEffect?: boolean) => void;
  setSelected: (index: any) => void;
  setCurrentSelection: React.Dispatch<any>;
  onUpdate: (e: Target) => Promise<void>;
  setCurrentIndex: React.Dispatch<any>;
};

const List = ({
  listId,
  labelId,
  listClassName,
  options,
  name,
  currentIndex,
  listboxStyle,
  currentSelection,
  listref,
  defaultValue,
  type,
  expanded,
  limit,
  columns,
  iconOnTheRight,
  handleItemClick,
  setSelected,
  setCurrentSelection,
  onUpdate,
  setCurrentIndex,
}: ListProps) => {
  const isListBox = type === FieldType.LISTBOX;
  const [showMore, setShowMore] = useState(limit !== undefined);

  const handleButtonKeyDown = (e: any) => {
    const keyCode = e.which || e.keyCode;
    const allowedKeys = [13, 32]; // Enter, Space
    if (allowedKeys.includes(keyCode)) {
      const selected = options[currentIndex];
      let newSelection = currentSelection.filter((o: any) => o.value !== defaultValue);

      if (newSelection.filter((o: any) => o.value === selected.value).length > 0) {
        newSelection = newSelection.filter((o: any) => o.value !== selected.value);
      } else {
        newSelection.push(selected);
      }
      if (newSelection.length === 0) {
        newSelection = options.filter((o: any) => o.value === defaultValue);
        setSelected(0);
      } else {
        setSelected(currentIndex);
      }
      setCurrentSelection(newSelection);
      onUpdate({
        target: {
          name,
          value: newSelection.filter((o: any) => o.value !== defaultValue).map((o: any) => o.value),
        },
      });
    }
  };

  const handleOnFocus = (e: any, i: number) => {
    setSelected(i);
    setCurrentIndex(i);
  };

  return (
    <ul
      {...{
        className: sumClasses(['listbox-box-shadow', listClassName, columns === 2 ? 'two-columns' : '']),
        id: listId,
        ref: listref,
        tabIndex: -1,
        role: 'listbox',
        'aria-labelledby': labelId,
        ...(options.length > 0 && options?.[currentIndex]
          ? { 'aria-activedescendant': `exp_elem_${name}_${options[currentIndex].value}` }
          : {}),
        style: { ...listboxStyle, overflow: 'visible' },
      }}
    >
      {options.map((item: any, i: number) => {
        const { value, className, disabled, addLabel, label, customSelectedIcon, hide } = item;
        const hideItem = showMore && limit ? i > limit : hide;
        const isSelected = isListBox
          ? currentSelection && currentSelection.value === value
          : currentSelection && currentSelection.filter((x: any) => x.value === value).length > 0;

        return (
          <ListItem
            key={`exp_elem_${name}_${value}`}
            name={name}
            value={value}
            defaultValue={defaultValue}
            className={className}
            disabled={disabled}
            i={i}
            currentIndex={currentIndex}
            isSelected={isSelected}
            addLabel={addLabel}
            currentSelection={currentSelection}
            expanded={expanded}
            labelId={labelId}
            isListBox={isListBox}
            item={item}
            label={label}
            hide={hideItem}
            columns={columns}
            customSelectedIcon={customSelectedIcon}
            iconOnTheRight={iconOnTheRight}
            handleItemClick={handleItemClick}
            handleOnFocus={handleOnFocus}
            handleButtonKeyDown={handleButtonKeyDown}
          />
        );
      })}
    </ul>
  );
};

export default List;
